// extracted by mini-css-extract-plugin
module.exports = {"section":"XTWRvcmaGd8AlkJz_cpj","type":"uKBQzLoaTGMaltXuvuF9"};